(() => {
  const initTabs = (root) => {
    if (root.classList.contains('is-ready')) return;
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = tabs.map((tab) => root.querySelector('#' + tab.getAttribute('aria-controls')));

    const select = (index, focus) => {
      tabs.forEach((tab, i) => {
        const active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (panels[i]) panels[i].hidden = !active;
      });
      if (focus) tabs[index].focus();
    };

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(i, false));
      tab.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== null) {
          event.preventDefault();
          select(next, true);
        }
      });
    });

    root.classList.add('is-ready');
    select(0, false);
  };

  const initSticky = (bar) => {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const form = document.getElementById(bar.dataset.form);
    const button = bar.querySelector('[data-grn-sticky-btn]');
    const price = bar.querySelector('[data-grn-sticky-price]');
    const sectionId = bar.dataset.section;
    if (!form) return;

    const setVisible = (visible) => {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (button) button.tabIndex = visible ? 0 : -1;
    };

    const anchor = form.querySelector('[type="submit"]') || form;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        ([entry]) => setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0),
        { threshold: 0 }
      ).observe(anchor);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && button) {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event && event.data;
        if (!data || data.sectionId !== sectionId) return;
        const variant = data.variant;
        if (!variant) {
          button.disabled = true;
          button.textContent = button.dataset.labelNa;
          return;
        }
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.labelAdd : button.dataset.labelSold;
        if (price && data.html) {
          const source = data.html.getElementById('price-' + sectionId);
          if (source) {
            const onSale = source.querySelector('.price--on-sale');
            const node = onSale
              ? source.querySelector('.price__sale .price-item--last')
              : source.querySelector('.price__regular .price-item--regular');
            if (node) price.textContent = node.textContent.trim();
          }
        }
      });
    }
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-grn-tabs]').forEach(initTabs);
    scope.querySelectorAll('[data-grn-sticky]').forEach(initSticky);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

(() => {
  if (!window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) return;
  const limit = 7;
  let active = null;
  let frame = 0;

  const reset = () => {
    if (!active) return;
    active.style.transform = '';
    active.classList.remove('grn-is-tilting');
    active = null;
  };

  document.addEventListener('pointermove', (event) => {
    const target = event.target.closest ? event.target.closest('[data-grn-tilt], .grn-card__media') : null;
    if (target !== active) reset();
    if (!target) return;
    active = target;
    const x = event.clientX;
    const y = event.clientY;
    window.cancelAnimationFrame(frame);
    frame = window.requestAnimationFrame(() => {
      const box = target.getBoundingClientRect();
      const px = (x - box.left) / box.width - 0.5;
      const py = (y - box.top) / box.height - 0.5;
      target.classList.add('grn-is-tilting');
      target.style.transform = 'perspective(800px) rotateX(' + (-py * limit).toFixed(2) + 'deg) rotateY(' + (px * limit).toFixed(2) + 'deg)';
    });
  });
  document.addEventListener('pointerleave', reset);
  window.addEventListener('blur', reset);
})();
